const formatChartNumber = (value: string) =>
  Intl.NumberFormat('en', {
    notation: 'compact',
  }).format(parseFloat(value));

export default formatChartNumber;
